import { useMemo, useState } from "react";
import { Search } from "lucide-react";
import { FAQS } from "../data/business";
import { SectionHeading } from "../components/SectionHeading";
import { FAQAccordion } from "../components/FAQAccordion";
import { CTASection } from "../components/CTASection";
import { useSEO } from "../hooks/useSEO";

const CATEGORIES = ["All", "Booking", "Services", "Location", "Hours", "Pricing", "Payments", "Appointments"];

export default function FAQ() {
  useSEO(
    "FAQ | New Lookz Hair Salon — Gandhi Nagar, Hyderabad",
    "Questions about booking, services, location, hours and pricing at New Lookz Hair Salon, Gandhi Nagar, Hyderabad.",
    "/faq"
  );

  const [query, setQuery] = useState("");
  const [cat, setCat] = useState("All");

  const faqs = useMemo(
    () =>
      FAQS.filter(
        (f) =>
          (cat === "All" || f.category === cat) &&
          (query === "" || `${f.q} ${f.a}`.toLowerCase().includes(query.toLowerCase()))
      ),
    [query, cat]
  );

  return (
    <>
      <section className="bg-ink grain" data-testid="faq-hero">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 text-center">
          <SectionHeading dark align="center" eyebrow="FAQ" title="Questions Before Your Visit?" />
          <div className="relative mt-10 max-w-md mx-auto">
            <Search size={17} className="absolute left-4 top-1/2 -translate-y-1/2 text-mute" aria-hidden="true" />
            <input
              type="search"
              aria-label="Search questions"
              data-testid="faq-search"
              placeholder="Search questions…"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="w-full rounded-full bg-coal border border-white/15 pl-11 pr-5 py-3.5 text-sm text-white placeholder:text-white/40 focus:border-copper transition-colors"
            />
          </div>
        </div>
      </section>

      <section className="bg-ivory">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20">
          <div className="flex flex-wrap gap-2 mb-8" role="group" aria-label="Filter questions by category">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                type="button"
                data-testid={`faq-filter-${c.toLowerCase()}`}
                aria-pressed={cat === c}
                onClick={() => setCat(c)}
                className={`rounded-full px-4 py-1.5 text-xs font-semibold font-display tracking-wide border transition-colors duration-300 ${
                  cat === c ? "bg-ink text-ivory border-ink" : "border-ink/20 text-body hover:border-copper hover:text-copper"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
          {faqs.length ? (
            <FAQAccordion key={`${cat}-${query}`} faqs={faqs} />
          ) : (
            <p className="text-center text-mute text-sm py-10" data-testid="faq-no-results">
              No questions match your search. Call us on +91 88863 93777 and we'll help directly.
            </p>
          )}
        </div>
      </section>

      <CTASection />
    </>
  );
}
